import { THEMES } from './index.js';

// Have to be duplicated in getStoreDirectoryFiles, couse require.context() dosen't accept dynamic values
const ecomPath = '~/themes/ecom/store';
const novaportaPath = '~/themes/novaporta/store';
const ecaterixPath = '~/themes/ecaterix/store';
const foundationPath = '~/themes/foundation/store';
const farmaciePath = '~/themes/farmacie/store';

export const getStoreDirectoryPath = theme => {
    if (THEMES.novaporta === theme) return novaportaPath;
    if (THEMES.ecaterix === theme) return ecaterixPath;
    if (THEMES.foundation === theme) return foundationPath;
    if (THEMES.farmacie === theme) return farmaciePath;
    else return ecomPath;
};

export const getStoreModule = theme => {
    if (THEMES.novaporta === theme) return require.context('~/themes/novaporta/store', true, /\.js$/);
    if (THEMES.ecaterix === theme) return require.context('~/themes/ecaterix/store', true, /\.js$/);
    if (THEMES.foundation === theme) return require.context('~/themes/foundation/store', true, /\.js$/);
    if (THEMES.farmacie === theme) return require.context('~/themes/farmacie/store', true, /\.js$/);
    else return require.context('~/themes/ecom/store', true, /\.js$/);
};
